import { useUserOrDefaultProvince } from '../../../utils/sitecoreContext';
import getVehiclesAvailableInProvince from '../utils/getVehiclesAvailableInProvince';
const useFilterByAvailableProvinces = (catalog) => {
    const provinceCode = useUserOrDefaultProvince();
    if (!Array.isArray(catalog) && !catalog)
        return null;
    return getVehiclesAvailableInProvince(catalog, provinceCode);
};
export default useFilterByAvailableProvinces;
